import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';


export const TenableAccordion = ({ image, title, heading, description }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className={`tenable-accordion-item ${isActive ? 'active' : ''}`}>
      <div className="tenable-accordion-header" onClick={() => setIsActive(!isActive)}>
        <div className="tenable-accordion-title-group">
          <img src={image} alt="" className="tenable-accordion-icon" />
          <h3 className="tenable-accordion-title">{title}</h3>
        </div>
        <div className="tenable-accordion-toggle">
          {isActive ? <FaChevronUp /> : <FaChevronDown />}
        </div>
      </div>
      {isActive && (
        <div className="tenable-accordion-body fade-in">
          <h4 className="tenable-accordion-heading">{heading}</h4>
          <p className="tenable-accordion-description">{description}</p>
        </div>
      )}
    </div>
  );
};